/**
 * @generated SignedSource<<70117e71c9fe65ba3506993e8cd5f3b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAccountsScreenQuery$variables = Record<PropertyKey, never>;
export type ServiceAccountsScreenQuery$data = {
  readonly store: {
    readonly serviceAccounts: ReadonlyArray<{
      readonly authTokens: ReadonlyArray<{
        readonly createdAt: {
          readonly storeFormattedDate: string;
        };
        readonly expiresAt: {
          readonly isoString: string;
          readonly storeFormattedDate: string;
        } | null;
        readonly id: string;
        readonly lastUsedAt: {
          readonly storeFormattedDate: string;
        } | null;
      }>;
      readonly id: string;
      readonly name: string | null;
    }>;
  };
};
export type ServiceAccountsScreenQuery = {
  response: ServiceAccountsScreenQuery$data;
  variables: ServiceAccountsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceAccount",
  "kind": "LinkedField",
  "name": "serviceAccounts",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceAccountAuthToken",
      "kind": "LinkedField",
      "name": "authTokens",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "createdAt",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "style",
                  "value": "SHORT_DATE"
                }
              ],
              "kind": "ScalarField",
              "name": "storeFormattedDate",
              "storageKey": "storeFormattedDate(style:\"SHORT_DATE\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "lastUsedAt",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "expiresAt",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoString",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceAccountsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ServiceAccountsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9233c0a6ffcee859dc439e286a5a9b04",
    "id": null,
    "metadata": {},
    "name": "ServiceAccountsScreenQuery",
    "operationKind": "query",
    "text": "query ServiceAccountsScreenQuery {\n  store {\n    serviceAccounts {\n      id\n      name\n      authTokens {\n        id\n        createdAt {\n          storeFormattedDate(style: SHORT_DATE)\n        }\n        lastUsedAt {\n          storeFormattedDate(style: DEFAULT)\n        }\n        expiresAt {\n          storeFormattedDate(style: DEFAULT)\n          isoString\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a777e00786e70146b28dac2f42bcdc1";

export default node;
